module.exports = __webpack_public_path__ + "img/login-background.84d0ed00.jpg";